<template>
  <div class="checkout-steps">
    <div class="checkout-steps__container">
      <template v-for="(step, index) in steps" :key="step">
        <div
          class="checkout-steps__item"
          :class="[
            activeStep === step && 'active',
            index < activeStepIndex && 'done',
          ]"
        >
          <div class="checkout-steps__number">
            <FontAwesomeIcon
              v-if="index < activeStepIndex"
              :icon="['fas', 'check']"
            />
            <span v-else>{{ index + 1 }}</span>
          </div>

          <span class="checkout-steps__label">
            {{
              (orderType === 'add-ons' && step === 'select-ticket') ||
              (!tickets.length && addOns.length && step === 'select-ticket')
                ? $t(
                    'landingpage.checkout-page.steps.title.additional-bookings',
                  )
                : $t(`landingpage.checkout-page.steps.title.${step}`)
            }}
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { inject } from 'vue'

defineProps({
  steps: { type: Array, default: () => [] },
})

const activeStep = inject('activeStep')
const activeStepIndex = inject('activeStepIndex')
const orderType = inject('orderType')
const tickets = inject('tickets')
const addOns = inject('addOns')
</script>
